import { MatSnackBar } from '@angular/material';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/snack-bar";
var SnackbarService = /** @class */ (function () {
    function SnackbarService(_snackBar) {
        this._snackBar = _snackBar;
    }
    SnackbarService.prototype.showSnackbar = function (message, action) {
        this._snackBar.open(message, action);
    };
    SnackbarService.ngInjectableDef = i0.defineInjectable({ factory: function SnackbarService_Factory() { return new SnackbarService(i0.inject(i1.MatSnackBar)); }, token: SnackbarService, providedIn: "root" });
    return SnackbarService;
}());
export { SnackbarService };
